import { MutationHookOptions, gql, useMutation } from '@apollo/client';

export const DELETE_COMPANY_LOGO = gql`
  mutation DeleteCompanyLogo($variant: LogoVariant!) {
    deleteCompanyLogo(variant: $variant) {
      id
      logoUrl
      lightLogoUrl
    }
  }
`;

export interface WhitelabelConfigLogoDeleteResultType {
  id: string;
  logoUrl: string;
  lightLogoUrl: string;
}

export interface DeleteCompanyLogoResult {
  deleteCompanyLogo: WhitelabelConfigLogoDeleteResultType;
}

export function useWhitelabelConfigLogoDeleteMutation(withRefetchQueries = true) {
  const mutationOpts: MutationHookOptions = {
    context: {
      headers: {
        'apollo-require-preflight': true,
      },
    },
  };
  if (withRefetchQueries) mutationOpts.refetchQueries = ['GetCompany'];
  return useMutation<DeleteCompanyLogoResult>(DELETE_COMPANY_LOGO, mutationOpts);
}
